<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <span class="ml-50 text-body">{{ currentOrigin.name }}</span>
    </template>
    <b-dropdown-item
      v-for="originObj in origin"
      :key="originObj.locale"
      @click="updateOrigin(originObj)"
    >
      <span class="ml-50">{{ originObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentOrigin() {
      return this.$store.state.auth.currentOrigin;
    },
    origin() {
      return this.$store.state.auth.currentUser.origin;
    },
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      {
        locale: 'fr',
        img: require('@/assets/images/flags/fr.png'),
        name: 'French',
      },
      {
        locale: 'de',
        img: require('@/assets/images/flags/de.png'),
        name: 'German',
      },
      {
        locale: 'pt',
        img: require('@/assets/images/flags/pt.png'),
        name: 'Portuguese',
      },
    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
  methods: {
    updateOrigin(data) {
      this.$store.dispatch('auth/updateCurrentOrigin', data);
    }
  }
}
</script>

<style>

</style>
